export class ResolverSupportingSlug {
  extractId(route, paramName, throwIfNoNumber = true) {
    let id = route.params[paramName] || null;
    // parse stringified numbers. will work too if the string contains a concatenated slug
    if (typeof id === 'string') id = parseInt(id, 10);
    if (isNaN(id)) id = null;
    if (id === null && throwIfNoNumber) throw new Error('Resolver: Could not extractId. Data is not a number.');
    return id;
  }
}